Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.TextFieldAutoSize = module.exports.default = {
	CENTER: "center",
	LEFT: "left",
	NONE: "none",
	RIGHT: "right"
};